import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const formatPriceRange = (min, max) => {
    if (min === max) return `$${Math.round(min)}`;
    return `$${Math.round(min)}–$${Math.round(max)}`;
};

export const categoryLabel = (cat) => {
    switch (cat) {
        case "smart-toilet": return "Smart Toilet";
        case "bidet-attachment": return "Bidet Attachment";
        case "wall-hung": return "Wall-Hung";
        case "accessory": return "Accessory";
        default: return cat;
    }
};

export const LOGO_URL = "/img/optim/itbmji3o_flowlux_logo-80.webp";
